import { MediaPlayer, TimeRange } from '@mi-front/core';
import { createStore, StoreApi } from 'zustand/vanilla';
import {
  BasePlaybackActions,
  BasePlaybackState,
  createBasePlaybackSlice,
  ExclusivePlaybackMode,
} from '../store/base-playback-slice';

export type AudioPlaybackState = BasePlaybackState;

export type AudioPlaybackActions = BasePlaybackActions;

export type AudioPlaybackStore = AudioPlaybackState & AudioPlaybackActions;

/**
 * Creates an audio playback store instance.
 * Requires a MediaPlayer instance to be provided.
 * Optionally accepts initial source URL and playback range for bounded playback.
 */
export function createAudioPlaybackStore({
  player,
  src,
  playbackRange,
  exclusivePlaybackMode = 'pause',
  playbackId,
}: {
  player: MediaPlayer | null;
  src?: string | null;
  playbackRange?: TimeRange<number> | null;
  exclusivePlaybackMode?: ExclusivePlaybackMode;
  playbackId?: string;
}): StoreApi<AudioPlaybackStore> {
  const store: StoreApi<AudioPlaybackStore> = createStore<AudioPlaybackStore>()((set, get, api) => {
    return {
      ...createBasePlaybackSlice<AudioPlaybackStore>()(set, get, api),
      mediaSrc: src ?? null,
      playbackRange: playbackRange ?? null,
      exclusivePlaybackMode,
      playbackId,
    };
  });

  // Set the provided player
  if (player) {
    store.getState().setupPlayer(player);
  }

  return store;
}

export type AudioPlaybackStoreApi = StoreApi<AudioPlaybackStore>;
